// extracted by mini-css-extract-plugin
export default {"MoneyWithDecimals":"MoneyWithDecimals_MoneyWithDecimals","decimals":"MoneyWithDecimals_decimals"};